<mat-horizontal-stepper>
    <mat-step [editable]="false">
        <div fxLayout="column">
            <ng-template matStepLabel>Welcome</ng-template>
            <p>Welcome, and congratulations on selecting HireLogic to manage your hire fleet.</p>
            <p>This step by step guide will help you add the information you need to get started with HireLogic.</p>
            <p>You will be asked to enter one or more customers and products, alternatively you can provide us with an
                Excel spreadsheet with all of your customers, and/or products. The template for these spreadsheets are
                available at each step.</p>
            <div fxLayout="row" fxLayoutAlign="end end">
                <button mat-raised-button matStepperNext color="primary">Start</button>
            </div>
        </div>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Users</ng-template>
        <p></p>

            <div fxLayout="row" fxLayoutAlign="end end">
                <button mat-raised-button matStepperPrevious>Previous</button>
                <button mat-raised-button matStepperNext color="primary">Next</button>
            </div>

    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Products</ng-template>
        <p></p>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Customers</ng-template>
        <p></p>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Done</ng-template>
        You are now done.
        <div>
            <button mat-button matStepperPrevious>Back</button>
        </div>
    </mat-step>
</mat-horizontal-stepper>